import { CloseLoopActionTypes, CloseLoopState } from "./types";
import { fetchError, fetchRequest, fetchSuccess } from "./actions";
import { createReducer } from "typesafe-actions";

export const initialState: CloseLoopState = {
  loading: false,
  errors: undefined,
  data: []
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>;

export default createReducer<CloseLoopState, ActionType>(initialState)
  .handleType(CloseLoopActionTypes.FETCH, state => ({
    ...state,
    loading: true,
    data: [],
    errors: undefined
  }))
  .handleType(CloseLoopActionTypes.FETCH_SUCCESS, (state, action) => ({
    ...state,
    loading: false,
    data: (action.payload.data ? action.payload.data : []),
    errors: undefined
  }))
  .handleType(CloseLoopActionTypes.FETCH_ERROR, (state, action) => ({
    ...state,
    loading: false,
    data: [],
    errors: action.payload
  }));
